'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.find')
require('core-js/modules/es.array.find-index')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.includes')
require('core-js/modules/es.array.map')
require('core-js/modules/es.array.splice')
require('core-js/modules/es.string.includes')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0
var _createClass2 = _interopRequireDefault(require('@babel/runtime/helpers/createClass'))
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _is = require('../is')
var _Task = _interopRequireDefault(require('./Task'))
var _requests = _interopRequireDefault(require('./requests'))

var DELAY = 3000
var TaskQueue = /*#__PURE__*/ (function() {
  function TaskQueue(arg) {
    ;(0, _defineProperty2.default)(this, 'tasks', [])
    ;(0, _defineProperty2.default)(this, 'interval', null)
    ;(0, _defineProperty2.default)(this, '_onTaskDoneCb', void 0)
    ;(0, _defineProperty2.default)(this, 'requests', void 0)
    this.requests = new _requests.default({ api_url: arg.api_url, queue: this, token: arg.token })
    this._onTaskDoneCb = arg.onTaskDone
  }
  var _proto = TaskQueue.prototype
  _proto.createTask = function createTask(arg) {
    var t = new _Task.default(arg, this)
    this.tasks.push(t)
    this._startExpecting()
  }
  _proto.findTaskById = function findTaskById(id) {
    var task = this.tasks.find(function(t) {
      return t.id === id
    })
    return task === undefined ? null : task
  }
  _proto.removeTask = function removeTask(id) {
    var taskInd = this.tasks.findIndex(function(t) {
      return t.id === id
    })
    if (taskInd === -1) return
    this.tasks[taskInd].destroy()
    this.tasks.splice(taskInd, 1)
  }
  _proto._startExpecting = function _startExpecting() {
    var _this = this
    if (!(0, _is.isNull)(this.interval)) return

    if (this.tasks.length === 0) {
      this._stopExpecting()
      return
    }

    this.interval = setTimeout(function() {
      _this.requests.fetch({ ids: _this.taskIds })
    }, DELAY)
  }
  _proto._setThatFailed = function _setThatFailed(ids) {
    this.tasks.forEach(function(t) {
      if (ids.includes(t.id)) {
        t.setThatFailed()
      }
    })
  }
  _proto._stopExpecting = function _stopExpecting() {
    window.clearTimeout(this.interval)
    this.interval = null
    this.requests.stop()
  }
  _proto._updateTasks = function _updateTasks(data) {
    var _this2 = this
    data.tasks.forEach(function(tdata) {
      var t = _this2.findTaskById(tdata.id)
      if (!(0, _is.isNull)(t)) {
        t.update(tdata)
      }
    })
  }
  _proto._onRequestComplete = function _onRequestComplete(resp) {
    if (resp.hasErr) {
      console.log('TCL: TaskQueue -> this.interval -> err', resp)
      this._setThatFailed(resp.ids)
    } else {
      this._updateTasks(resp)
    }

    this._stopExpecting()
    this._startExpecting()
  }
  _proto._onTaskDone = function _onTaskDone(arg) {
    if ((0, _is.isF)(this._onTaskDoneCb)) {
      this._onTaskDoneCb(arg)
    }
    this.removeTask(arg.id)
  }
  ;(0, _createClass2.default)(TaskQueue, [
    {
      key: 'taskIds',
      get: function get() {
        return this.tasks.map(function(t) {
          return t.id
        })
      }
    }
  ])
  return TaskQueue
})()
var _default = TaskQueue
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TaskQueue/index.js
// module id = 620
// module chunks = 0